<div class="mb-1 d-flex justify-content-between align-items-center">
  <span class="text-sm fw-bold">Jobs running: {{ runningJobCount }}</span>

  @if (runningJobCount > 0) {
    <button class="btn btn-sm btn-secondary" (click)="cancelAllJobs()">Cancel all</button>
  }
</div>
<table class="table bg-white table-bordered table-sm text-sm">
  <thead>
    <tr>
      <th>Tool</th>
      <th>Start Time</th>
      <th>Duration</th>
      <th>Status</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <!-- add id to be able to scroll to the selected job -->
    @for (job of jobsSorted; track job.jobId) {
      <tr
        class="cursor-pointer hoverable-row"
        (click)="selectJob(job)"
        [ngClass]="{ 'table-active': isSelectedJobById(job.jobId) }"
        attr.id="job-id-{{ job.jobId }}">
        <td>{{ job.toolName }}</td>
        <td class="text-sm" [ngClass]="isSelectedJobById(job.jobId) ? 'text-light' : 'lighter'">
          {{ job.created | localDate }}
        </td>

        <td class="text-sm" [ngClass]="isSelectedJobById(job.jobId) ? 'text-light' : 'lighter'">
          {{ getDurationObservable(job) | async }}
        </td>

        <td>
          {{ job.state }}
        </td>
        @if (isRunning(job)) {
          <td valign="top">
            <ch-link-button class="cancel-button" (click)="$event.stopImmediatePropagation(); cancelJob(job)">
              Cancel
            </ch-link-button>
          </td>
        } @else {
          <td style="padding-left: 10px">&nbsp;</td>
        }
      </tr>
    }
  </tbody>
</table>
